import { render, staticRenderFns } from "./EditDisposal.vue?vue&type=template&id=efc208d0"
import script from "./EditDisposal.vue?vue&type=script&lang=js"
export * from "./EditDisposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports